<template>
    <div>
        <title-screen title ="15"></title-screen>
        <div class="anken-detail" v-if="hasAnken">
            <AnkenInfo :id="this.ankenId" @ankenInfoLoad="ankenInfoLoad"></AnkenInfo>
        </div>
        <div class="date-picker-box" id="app-date-picker" v-if="isLoaded">
            <div class="box-date">
                <div class="border-date-box-title has-border-right">
                    <span>相続開始日</span>
                </div>
                <div class="border-date-box has-border-right">
                    <el-date-picker v-model="deathDate"
                                    type="date"
                                    clearable
                                    :editable="false"
                                    format="yyyy年MM月dd日"
                                    @change="handleChangeDeathDate"
                                    value-format="yyyy-MM-dd"
                                    :picker-options="deathDatePickerOptions"
                                    clear-icon></el-date-picker>
                </div>
            </div>
            <div class="box-date">
                <div class="border-date-box-title">
                    <span>葬儀日</span>
                </div>
                <div class="border-date-box">
                    <el-date-picker v-model="funeralDate"
                                    type="date"
                                    clearable
                                    :editable="false"
                                    format="yyyy年MM月dd日"
                                    @change="handleChangeFuneralDate"
                                    value-format="yyyy-MM-dd"
                                    :picker-options="funeralDatePickerOptions"
                                    clear-icon></el-date-picker>
                </div>
            </div>
        </div>
        <div style="margin-top: 2%">
            <ul class="flex">
                <li>
                    <p>相続手続きを行うためのチェックリストです。</p>
                    <p>※ 期限日は参考としてください。期限日については必ず提出先機関へご確認してください。</p>
                </li>
            </ul>
        </div>
        <div class="app-list-data">
            <div  class="table-responsive table-invoice-flag">
                <table class="el-table-cus table m-0 no-border-radius">
                    <thead class="border-bottom-custom">
                        <tr>
                            <th style="min-width: 50px">完了チェック</th>
                            <th style="min-width: 80px;">手続の種類</th>
                            <th style="min-width: 80px;">期限</th>
                            <th style="min-width: 80px; width: 160px;">期限日</th>
                            <th style="min-width: 80px;">提出・請求先</th>
                            <th style="min-width: 45px">レガシィ代行可否</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="!tableData.length  || tableData.length === 0">
                            <tr class="empty-data">
                                <td colspan="6" class="el-table__empty-text">検索を行ってください。</td>
                            </tr>
                        </template>
                        <template v-for="(data, index) in formatTableData()">
                            <tr :key="index" :value="index" :class="getRowClassName(data)">
                                <td :class="getCellClassName(data,0)">
                                    <el-checkbox :value="data.flag" @change="handleCheckBox(data)"></el-checkbox>
                                </td>
                                <td :class="['procedure-type', getCellClassName(data,1)]">
                                    {{ data.procedureType }}
                                </td>
                                <td :class="getCellClassName(data,3)">
                                    {{ data.deadlineNote }}
                                </td>
                                <td :class="getCellClassName(data,3)">
                                    {{ data.date }}
                                </td>
                                <td :class="getCellClassName(data,4)">
                                    {{ data.note }}
                                </td>
                                <td v-if="data.showCol5" :rowspan="data.rowspan" :class="getCellClassName(data, 5)" class="white-space-nowrap">
                                    <router-link to="/contact" class="contact gtm_list_acting" v-if="data.linkToContact" target="_blank">
                                        <label style="writing-mode: vertical-rl; -ms-writing-mode: tb-rl;" class="gtm_list_acting"> {{ data.surrogate }} </label>
                                    </router-link>
                                    <label v-else style="writing-mode: vertical-rl; -ms-writing-mode: tb-rl;"> {{ data.surrogate }} </label>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
        <el-row v-if="isAuthenticated">
            <el-col align="center" style="padding-top: 2em">
                <el-button class="gtm_check_hozon_check" type="danger" @click="handleSave"><span class="gtm_check_hozon_check">保存</span></el-button>
            </el-col>
        </el-row>
        <el-row>
            <el-col align="center" style="padding-top: 2em" class="btn-contact">
                <el-button class="el-button-big gtm_check_soudan_check" @click="handleContact"><span class="gtm_check_soudan_check">手続きについて</span><br/><span class="gtm_check_soudan_check">より詳細に相談したい方はこちら</span></el-button>
            </el-col>
        </el-row>
        <div class="menu-dialog">
            <el-dialog
                :visible.sync="menuDialogVisible"
                :before-close="handleCloseMenu"
                :close-on-click-modal="false"
            >
            <p class="title">ご利用後にデータを保存したい方</p>
            <el-row>
            <el-col align="center" style="font-size: 16px"><p class="p-menu" v-html="login_register"></p></el-col>
            <div class="register-info" align="center">
            <span class="btn-register" @click="registerEmail">無料会員登録</span>
            <span class="btn-logout" @click="openLoginDialog">ログイン</span>
            </div>
            <p class="title">ご利用後にデータを保存しない方</p>
            <el-col align="center" style="font-size: 16px"><p class="p-menu" v-html="guest"></p></el-col>
            <div class="register-info" align="center">
            <span class="btn-register" @click="handleCloseMenu">保存せずに利用開始</span>
            </div>
            </el-row>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import AnkenInfo from '../38_anken/AnkenInfo'
import TitleScreen from '@/components/common/TitleScreen'
import ApiHoliday from '@/api/invoice/holiday.js'
import ApiInvoice from '@/api/invoice/invoice.js'
import { MessageBox } from 'element-ui'
import moment from 'moment'
import { isIE } from '@/common/useragent'
import { mapGetters } from 'vuex'
import { SET_OPEN_LOGIN_DIALOG, SET_OPEN_REGISTER_DIALOG } from '@/store/actions.type'
import anken from '@/api/anken/anken-cl.js'

export default {
    name: 'invoice-flag',
    components: {
        TitleScreen,
        AnkenInfo
    },
    data () {
        return {
            ankenId: null,
            deathDate: new Date(),
            funeralDate: new Date(),
            inheritances: [],
            datePickerData: [],
            tableData: [],
            holiday: [],
            hasAnken: false,
            isLoaded: false,
            isAnkenInfoLoaded: false,
            isUpdate: false,
            lastUpdated: null,
            menuDialogVisible: false,
            login_register: 'ご利用開始前に、無料会員登録をお願い致します。</BR>会員登録済みの方は、ログイン後にご利用ください。',
            guest: 'ご利用開始前に、無料会員登録またはログインを</BR>されない場合は、データの保存がされません。'
        }
    },
    computed: {
        ...mapGetters(['isAuthenticated']),
        deathDatePickerOptions () {
            let self = this
            return {
                disabledDate (date) {
                    let checkWithFuneralDate = self.funeralDate !== null && moment(date).isAfter(self.funeralDate)
                    let fiveYearBefore = moment().subtract(5, 'y')
                    let _30DayLater = moment().add(30, 'd')
                    return checkWithFuneralDate || moment(date).isBefore(fiveYearBefore) ||
                        moment(date).isAfter(_30DayLater)
                }
            }
        },
        funeralDatePickerOptions () {
            let self = this
            return {
                disabledDate (date) {
                    let checWithDeathDate = false
                    if (self.deathDate !== null) {
                        let oneMonthLater = moment(self.deathDate).add(1, 'M').subtract(1, 'd')
                        checWithDeathDate = moment(date).isBefore(self.deathDate) || moment(date).isAfter(oneMonthLater)
                    }
                    return checWithDeathDate
                }
            }
        }
    },
    created () {
        this.loadData()
    },
    methods: {
        formatTableData () {
            let totalRowspan = 0
            let vm = this
            for (let i = 0; i < vm.tableData.length; i++) {
                if (totalRowspan === i) {
                    vm.tableData[i].showCol5 = true
                    totalRowspan += vm.tableData[i].rowspan
                } else {
                    vm.tableData[i].showCol5 = false
                }
            }
            return vm.tableData
        },
        getRowClassName (data) {
            if (data.flag === true) {
                return 'invoice-selected-row'
            }
        },
        getCellClassName (row, columnIndex) {
            if (columnIndex === 5) {
                return 'td__background--default'
            }
            return row.compare === true && !row.flag ? 'background-date-child' : ''
        },
        getHoliday: async function () {
            const res = await ApiHoliday.getHoliday()
            if (res.data.status === 200) {
                let data = res.data.data
                this.holiday = data.map(h => this.formatDate(h.date))
            }
        },
        loadDefaultInheritance: async function () {
            const res = await ApiInvoice.getInvoice()
            if (res.data) {
                if (this.isAuthenticated) {
                    const data = res.data
                    this.isUpdate = data.inheritanceAnkenManager.id != null
                    this.deathDate = data.inheritanceAnkenManager.inheritanceDate ?? new Date()
                    this.funeralDate = data.inheritanceAnkenManager.funeralDate ?? new Date()
                    this.lastUpdated = data.inheritanceAnkenManager.updatedAt
                    this.inheritances = data.inheritanceMapMasters
                } else {
                    this.inheritances = res.data
                }
                this.makeTableData()
            }
        },
        loadInheritanceByAnkenId: async function () {
            const res = await ApiInvoice.getInheritanceByAnkenId(this.ankenId)
            if (res.data) {
                const data = res.data
                this.isUpdate = data.inheritanceAnkenManager.id != null
                this.deathDate = data.inheritanceAnkenManager.inheritanceDate
                this.funeralDate = data.inheritanceAnkenManager.funeralDate
                this.lastUpdated = data.inheritanceAnkenManager.updatedAt
                this.inheritances = data.inheritanceMapMasters
                this.makeTableData()
            }
        },
        makeTableData () {
            for (var i = 0, oldIdx = 0, oldIsActable = null; i < this.inheritances.length; i++) {
                if (oldIsActable === this.inheritances[i].isActable) {
                    this.inheritances[i].rowspan = 0
                    this.inheritances[oldIdx].rowspan += 1
                } else {
                    oldIsActable = this.inheritances[i].isActable
                    oldIdx = i
                    this.inheritances[i].rowspan = 1
                }
                if (this.inheritances[i].updatedAt > this.lastUpdated) this.lastUpdated = this.inheritances[i].updatedAt
            }
            this.tableData = this.inheritances.map(d => {
                const date = d.datelineDateType === 'inheritance' ? this.deathDate : this.funeralDate
                const plusDate = this.getPlusDate(date, d.plusTimeType, d.plusTime)
                const dateNextHoliday = this.getDateNextHoliday(plusDate, d.deadlineTimeType, d.deadline)
                return {
                    id: d.id,
                    inheritanceMapId: d.inheritanceMapId,
                    key: d.id,
                    isDefaultFlag: d.isChecked,
                    flag: !!d.isChecked,
                    procedureType: d.procedureType,
                    deadlineNote: d.deadlineNote,
                    isRealDate: !!d.deadline,
                    date: d.deadline ? dateNextHoliday : d.deadlineNote,
                    note: d.note,
                    linkToContact: d.isActable,
                    surrogate: d.isActable ? '可能(ご依頼はコチラ)' : '不可',
                    compare: this.compareDate(dateNextHoliday),
                    rowspan: d.rowspan
                }
            })
            this.datePickerData = [
                { deathDate: this.deathDate, funeralDate: this.funeralDate }
            ]
            this.isLoaded = true
        },
        changeDate (datelineDateType, date) {
            for (var i = 0, len = this.inheritances.length; i < len; ++i) {
                const d = this.inheritances[i]
                const plusDate = this.getPlusDate(date, d.plusTimeType, d.plusTime)
                let dateNextHoliday = this.getDateNextHoliday(plusDate, d.deadlineTimeType, d.deadline)
                if (d.datelineDateType === datelineDateType && d.deadline) {
                    this.tableData[i].date = dateNextHoliday
                }
                this.tableData[i].compare = this.compareDate(dateNextHoliday)
            }
        },
        handleSave: async function () {
            let oneMonthDeadLater = moment(this.deathDate).add(1, 'M').subtract(1, 'd')
            if (moment(this.funeralDate).isAfter(oneMonthDeadLater)) {
                this.$msgbox({
                    title: '葬儀日は相続開始日から30日以内で選択してください',
                    showClose: true,
                    center: true,
                    confirmButtonClass: 'btn-msg-box'
                })
                return
            }
            const dataTableReq = this.isUpdate ? this.tableData.filter(d => d.flag !== d.isDefaultFlag) : this.tableData
            const inheritanceMapMasters = dataTableReq.map(d => {
                return {
                    inheritanceMapId: d.inheritanceMapId,
                    inheritanceMasterId: d.id,
                    isChecked: d.flag,
                    deadline: d.isRealDate ? this.formatMomentDate(d.date) : null
                }
            })
            const payload = {
                inheritanceMapMasters,
                deathDate: this.deathDate,
                funeralDate: this.funeralDate
            }
            let res
            if (this.hasAnken) {
                res = await ApiInvoice.createInvoice(this.ankenId, payload)
            } else {
                res = await ApiInvoice.createInvoiceByMember(payload)
            }
            const inheritanceAnkenMaps = res.data
            this.inheritances.forEach(i => {
                const ankenMap = inheritanceAnkenMaps.find(im => +im.inheritanceMasterId === +i.id)
                if (ankenMap) {
                    i.inheritanceMapId = ankenMap.id
                    i.isChecked = ankenMap.isChecked
                }
            })
            this.makeTableData()

            const title = this.isUpdate ? '更新しました。' : '登録しました。'
            MessageBox({
                title: title,
                showClose: true,
                center: true,
                confirmButtonClass: 'btn-msg-box'
            })
            setTimeout(() => { MessageBox.close() }, 2000)
        },
        compareDate (date) {
            if (date === null) return false
            let dateNow = moment()
            return moment(date, moment.defaultFormat).isBefore(dateNow, 'day')
        },
        objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 5) {
                if (row.rowspan > 0) {
                    return {
                        rowspan: row.rowspan,
                        colspan: 1
                    }
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    }
                }
            }
        },
        handleChangeDeathDate (val) {
            if (val > this.funeralDate) {
                this.$notify.warning({
                    title: '警告',
                    message: '埋葬日は死亡日以降で設定してください。'
                })
            } else {
                this.deathDate = val
                this.changeDate('inheritance', val)
            }
        },
        handleChangeFuneralDate (val) {
            if (val < this.deathDate) {
                this.$notify.warning({
                    title: '警告',
                    message: '埋葬日は死亡日以降で設定してください。'
                })
            } else {
                this.funeralDate = val
                this.changeDate('funeral', val)
            }
        },
        handleCheckBox (row) {
            this.$set(row, 'flag', !row.flag)
        },
        formatDate (date, format = 'YYYY年MM月DD日 (ddd)') {
            return date ? moment(date, moment.defaultFormat).locale('ja').format(format) : null
        },
        formatMomentDate (date) {
            if (date !== null) {
                return moment(date, moment.defaultFormat).format('YYYY-MM-DD')
            }
            return null
        },
        getPlusDate (date, intervalType, interval) {
            if (!date) return null

            if (!intervalType || !interval) {
                return date
            }

            let formattedDate = null
            if (intervalType === 'day') {
                formattedDate = moment(date).add(interval, 'd')
            }

            return formattedDate ? this.formatMomentDate(formattedDate) : null
        },
        getDateNextHoliday (date, intervalType, interval) {
            if (!date || !intervalType || !interval) return null

            let formattedDate = null
            if (intervalType === 'day') {
                formattedDate = moment(date).add(interval, 'd')
            }

            if (intervalType === 'month') {
                formattedDate = moment(date).add(interval, 'M')
            }

            if (intervalType === 'year') {
                formattedDate = moment(date).add(interval, 'y')
            }

            return formattedDate ? this.formatDate(this.getValidDate(formattedDate)) : null
        },
        getValidDate (date) {
            while (this.holiday.includes(moment(date, moment.defaultFormat).locale('ja').format('YYYY年MM月DD日 (ddd)')) || this.isWeekend(date)) {
                date = moment(date).add(1, 'd')
            }
            return date
        },
        isWeekend (date) {
            let day = moment(date).toDate().getDay()
            return ((day === 6) || (day === 0))
        },
        tableRowClassName ({ row }) {
            if (row.flag === true) {
                return 'invoice-selected-row'
            }
        },
        cellClassName ({ row, columnIndex }) {
            if (columnIndex === 5) {
                return 'td__background--default'
            }

            return row.compare === true && !row.flag ? 'background-date-child' : ''
        },
        ankenInfoLoad (val) {
            this.isAnkenInfoLoaded = val
        },
        scrollDatePickerView () {
            if (this.isAnkenInfoLoaded && this.isLoaded) {
                this.$nextTick(() => {
                    const ankenViews = document.getElementsByClassName('anken-info')
                    if (ankenViews.length > 0) {
                        const ankenView = ankenViews[0]
                        if (ankenView) {
                            var navHeight = 0
                            if (window.innerWidth > 600 && window.innerHeight > 400) {
                                const navViews = document.getElementsByClassName('img-logo')
                                if (navViews.length > 0) {
                                    const navView = navViews[0]
                                    if (navView) {
                                        navHeight = navView.offsetHeight
                                        if (!isIE() && this._$(navView).css('position') === 'static') navHeight += 60
                                    }
                                }
                            }
                            const scrollTop = ankenView.offsetTop + ankenView.offsetHeight - navHeight
                            window.scroll(0, scrollTop)
                        }
                    }
                })
            }
        },
        readyForDatePicker () {
            if (this.isAnkenInfoLoaded && this.isLoaded) {
                this.$nextTick(() => {
                    if (isIE()) {
                        this._$('.date-picker-box input[type="text"]').on('focus', event => event.currentTarget.blur())
                    }
                })
            }
        },
        handleContact () {
            let routeData = this.$router.resolve({ name: 'contact' })
            window.open(routeData.href, '_blank')
        },
        handleCloseMenu () {
            this.menuDialogVisible = false
        },
        openLoginDialog () {
            this.$store.dispatch(SET_OPEN_LOGIN_DIALOG, true)
        },
        registerEmail () {
            this.$store.dispatch(SET_OPEN_REGISTER_DIALOG, true)
        },
        async loadData () {
            this.ankenId = parseInt(this.$route.params.id)
            this.getHoliday()

            if (this.ankenId > 0) {
                this.hasAnken = true
                this.loadInheritanceByAnkenId(this.ankenId)
            } else {
                this.hasAnken = false
                this.loadDefaultInheritance()
            }
            if (this.isAuthenticated) {
                this.menuDialogVisible = false
            } else {
                this.menuDialogVisible = true
            }
        }
    },
    watch: {
        isAnkenInfoLoaded: function () {
            this.scrollDatePickerView()
            this.readyForDatePicker()
        },
        isLoaded: function () {
            this.scrollDatePickerView()
            this.readyForDatePicker()
        },
        isAuthenticated: function (newValue, oldValue) {
            if (newValue) {
                anken.getAnkenFilterList().then(response => {
                    if (response.data.length > 0) {
                        // 案件があるユーザはご依頼一覧へ遷移する。
                        this.$router.push({ name: 'anken' })
                    } else {
                        // ポップアップからログインして案件が無いユーザの場合は、データを再読み込みする。
                        this.loadData()
                    }
                })
            }
        }
    },
    filters: {
        formatDate: function (value) {
            if (value) {
                return moment(value).format('YYYY[年]MM[月]DD[日]')
            }
        }
    }
}
</script>

<style scoped>
    @import "../../../../assets/css/custom.css";
    .date-picker {
        padding-top: 2em;
        padding-bottom: 1em;
    }
    .contact {
        text-decoration: underline;
        color: blue;
    }
    .contact :hover {
        cursor: pointer;
    }
    .table-data {
        width: 60%;
    }
    .table-data .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: unset;
    }
    @media screen and (max-width:480px) {
        .table-data {
            width: 100%;
        }
    }
    @media screen and (min-width:768px) {
        .table-invoice-flag {
            overflow-x: unset;
        }
    }
    .table-invoice-flag table td .content {
        text-align: left;
    }
    .table-invoice-flag table td .content img {
        width: 100%;
        height: 150px;
    }
    .table-invoice-flag table .note {
        margin-top: 10px;
        padding-left: 5px;
        margin-bottom: 10px;
    }
    .table-invoice-flag table tr td a {
        color: #3a8ee6 !important;
    }
    .table-invoice-flag table {
        width: 100%;
        margin: 1em auto;
        /*border: 2px solid #d6d6d6;*/
    }
    .table-invoice-flag .table td {
        text-align: center;
        padding: 1em;
        /*background: #e6f6fe;*/
        font-size: 14px;
        vertical-align: middle;
    }
    .table-invoice-flag .table .bg-blue td {
        background: #8edbff;
    }
    .table-invoice-flag .table .bg-lightblue td {
        background: #e6f6fe;
    }
    .table-invoice-flag .table th {
        text-align: center;
        background-color: #f7f0df ;
        padding: 1em;
        font-size: 16px;
        font-weight: bold;
        color: #321007;
    }
    .table-invoice-flag .table th {
        vertical-align: middle;
    }
    .table-invoice-flag tbody tr:hover>td {
        background-color: #F5F7FA;
    }
    td.td__background--default {
        background: transparent!important;
    }
    .menu-dialog .el-dialog {
        width: 50%;
        min-width: 320px;
    }
    .menu-dialog .btn-end-dialog {
        text-align: center;
    }
    .menu-dialog .title {
        text-align: center;
        text-decoration:underline;
        font-size: 22px;
        margin-top: 10px;
    }
    .menu-dialog .p-menu {
        width: 400px;
        line-height: 20px;
        padding-bottom: 30px;
        padding-top: 10px
    }
    .menu-dialog .register-info {
        width: unset;
    }
    _:-ms-lang(x)::-ms-backdrop, .menu-dialog .register-info {
        width: 100%;
    }
    .menu-dialog .btn-register {
        margin-right: 10px;
        padding: 5px 8px;
    }
    .menu-dialog .btn-logout {
        padding: 5px 8px;
        font-size: 15px;
    }
</style>
<style scoped>
  .btn-msg-box{
    background-color: #a5272a!important;
    color: #ffffff!important;
    font-weight: bold!important;
    text-align: center!important;
    border-radius: 5px!important;
    border-color: unset;
  }
  .btn-msg-box:hover{
    border-color: unset;
  }

  .border-date-box-title{
      /*border-right: 2px solid #d6d6d6 !important;*/
      /*border-bottom: 2px solid #d6d6d6 !important;*/
      border-bottom: 5px solid #ff9900 !important;
      text-align: center !important;
      font-size: 16px !important;
      background-color: #fffaf0 !important;
      font-weight: bold !important;
      color: #321007 !important;
      padding: 12px 0;
  }

    .border-date-box{
        /*border-right: 2px solid #d6d6d6 !important;*/
        /*border-bottom: 2px solid #d6d6d6 !important;*/
        text-align: center !important;
        font-size: 16px !important;
        font-weight: bold !important;
        color: #321007 !important;
        padding: 12px 10px;
        background-color: #fffafa !important;
    }
    .date-picker-box{
        /*border-left: 2px solid #d6d6d6 !important;*/
        /*border-top: 2px solid #d6d6d6 !important;*/
        display: flex;
        width: 60%
    }
    .box-date{
        display: flex;
        flex-flow: column;
        flex-grow: 1;
    }

   .border-date-box .el-date-editor.el-input, .el-date-editor.el-input__inner {
      width: unset;
  }
   .white-space-nowrap {
       white-space: nowrap;
   }

  @media screen and (max-width:768px) {
      .date-picker-box {
          width: 80% !important;
      }
  }

  @media screen and (max-width: 500px) {
      .date-picker-box {
          width: 90% !important;
      }
  }
  @media screen and (max-width: 450px) {
      .date-picker-box {
          margin: auto;
          flex-flow: column;
      }
  }
  .table {
      border-radius: unset !important;
  }
  .table thead th {
      border-bottom: 5px solid #ff9900;
  }
  .table thead th + th{
      border-left: 1px solid #d6d6d6 !important;
  }
  .table th {
     background-color: #fffaf0 !important;
  }
  .table tr {
      background-color: #fffafa;
  }
  .table td {
      background-color: #fffafa;
  }
  .table tbody td + td {
      border-left: 1px solid #d6d6d6 !important;
  }
  .table thead + tbody td {
      border-top: 1px solid #d6d6d6 !important;
  }
  @media screen and (min-width:768px) {
      .has-border-right {
          border-right: 1px solid #d6d6d6 !important;
      }
  }
  .procedure-type {
      white-space: pre-wrap!important;
      text-align: left!important;
      min-width: 150px;
  }
  .btn-contact button {
      line-height: normal;
  }
</style>
